import { call, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
  Settings,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { PS20Logger } from '@ps20-frontend/logging';
import { SettingsResponseModel } from '@ps20/bff-models';

const globalActions = new GlobalActions();

export enum SETTINGS_REQUESTED_EVENTS {
  SETTINGS_REQUESTED_SUCCESSFUL = 'SETTINGS_REQUESTED_SUCCESSFUL',
  SETTINGS_REQUESTED_FAILED = 'SETTINGS_REQUESTED_FAILED',
}
export function* watchSettingsRequestedEvent() {
  yield takeEvery(GlobalActions.AUTHENTICATION_SUCCESSFUL, safeSaga(callSettings, App.SHOP));
  yield takeEvery(
    SETTINGS_REQUESTED_EVENTS.SETTINGS_REQUESTED_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP),
  );
  yield takeEvery(
    SETTINGS_REQUESTED_EVENTS.SETTINGS_REQUESTED_FAILED,
    safeSaga(errorCallback, App.SHOP),
  );
}

function* getSettings() {
  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    globalActions.doRequest({
      appId: App.SHOP,
      url: 'privatschutz/api/settings',
      method: HTTP_METHOD.GET,
      successEvent: SETTINGS_REQUESTED_EVENTS.SETTINGS_REQUESTED_SUCCESSFUL,
      errorEvent: SETTINGS_REQUESTED_EVENTS.SETTINGS_REQUESTED_FAILED,
    }),
  );
}

export function* callSettings() {
  yield* getSettings();
}

export function* successCallback(successAction: DoRequestResponse<SettingsResponseModel>) {
  const globalPut = GlobalPut.getInstance();

  const settings: Settings = Object.keys(successAction.payload.settings).reduce(
    (tempSettings: Settings, key) => {
      tempSettings[key] = successAction.payload.settings[key];
      return tempSettings;
    },
    {},
  );
  yield call(globalPut.put, globalActions.settingsReceived(settings));
}

export function errorCallback(errorAction: DoRequestResponse<SettingsResponseModel>) {
  PS20Logger.error(App.SHOP, 'Loading settings from bff failed.', errorAction.payload.toString());
}
